import {
  GET_SUGGESTIONS,
  LOADING_SUGGESTIONS,
  GET_LIST_BRILINK,
  LOADING_LIST_BRILINK,
  POST_TINDAK_LANJUT,
  LOADING_TINDAK_LANJUT,
  GET_DETAIL_BRILINK,
  LOADING_DETAIL_BRILINK,
  GET_INFINITE_LIST_BRILINK,
  LOADING_INFINITE_LIST_BRILINK,
  GET_PROSES_KUNJUNGAN,
  LOADING_PROSES_KUNJUNGAN,
  GET_PERSENTASE_MINGGUAN,
  LOADING_PERSENTASE_MINGGUAN,
  GET_PERSENTASE_BULANAN,
  LOADING_PERSENTASE_BULANAN,
  GET_FILTER_KELURAHAN,
  LOADING_FILTER_KELURAHAN,
} from '../constants/brilink';

const initialState = {
  suggestionsData: [],
  listBrilinkData: { data: [] as object[] },
  postBrilinkResponse: {},
  detailBrilinkData: {},
  prosesKunjunganData: {},
  persentaseMingguanData: {},
  persentaseBulananData: {},
  listKelurahanData: [],
  isLoadingSuggestions: true,
  isLoadingBrilinkData: true,
  isLoadingPostBrilink: true,
  isLoadingDetailBrilink: true,
  isLoadingInfiniteList: true,
  isLoadingProsesKunjungan: true,
  isLoadingPersentaseMingguan: true,
  isLoadingPersentaseBulanan: true,
  isLoadingFilterKelurahan: true,
};

export default function reducer(
  state = initialState,
  action = {
    type: '',
    suggestionsData: [],
    listBrilinkData: { data: [] as object[] },
    postBrilinkResponse: {},
    detailBrilinkData: {},
    infiniteListData: { data: [] as object[] },
    prosesKunjunganData: {},
    persentaseMingguanData: {},
    persentaseBulananData: {},
    listKelurahanData: [],
  }
) {
  const {
    type,
    suggestionsData,
    listBrilinkData,
    postBrilinkResponse,
    detailBrilinkData,
    infiniteListData,
    prosesKunjunganData,
    persentaseMingguanData,
    persentaseBulananData,
    listKelurahanData,
  } = action;

  switch (type) {
    case GET_SUGGESTIONS:
      return {
        ...state,
        suggestionsData,
        isLoadingSuggestions: false,
      };
    case LOADING_SUGGESTIONS:
      return {
        ...state,
        isLoadingSuggestions: true,
      };
    case GET_LIST_BRILINK:
      return {
        ...state,
        listBrilinkData,
        isLoadingBrilinkData: false,
      };
    case LOADING_LIST_BRILINK:
      return {
        ...state,
        isLoadingBrilinkData: true,
      };
    case POST_TINDAK_LANJUT:
      return {
        ...state,
        postBrilinkResponse,
        isLoadingPostBrilink: false,
      };
    case LOADING_TINDAK_LANJUT:
      return {
        ...state,
        isLoadingPostBrilink: true,
      };
    case GET_DETAIL_BRILINK:
      return {
        ...state,
        detailBrilinkData,
        isLoadingDetailBrilink: false,
      };
    case LOADING_DETAIL_BRILINK:
      return {
        ...state,
        isLoadingDetailBrilink: true,
      };
    case GET_INFINITE_LIST_BRILINK:
      return {
        ...state,
        listBrilinkData: {
          ...infiniteListData,
          data: [...state.listBrilinkData.data, ...infiniteListData.data],
        },
        isLoadingInfiniteList: false,
      };
    case LOADING_INFINITE_LIST_BRILINK:
      return {
        ...state,
        isLoadingInfiniteList: true,
      };
    case GET_PROSES_KUNJUNGAN:
      return {
        ...state,
        prosesKunjunganData,
        isLoadingProsesKunjungan: false,
      };
    case LOADING_PROSES_KUNJUNGAN:
      return {
        ...state,
        isLoadingProsesKunjungan: true,
      };
    case GET_PERSENTASE_MINGGUAN:
      return {
        ...state,
        persentaseMingguanData,
        isLoadingPersentaseMingguan: false,
      };
    case LOADING_PERSENTASE_MINGGUAN:
      return {
        ...state,
        isLoadingPersentaseMingguan: true,
      };
    case GET_PERSENTASE_BULANAN:
      return {
        ...state,
        persentaseBulananData,
        isLoadingPersentaseBulanan: false,
      };
    case LOADING_PERSENTASE_BULANAN:
      return {
        ...state,
        isLoadingPersentaseBulanan: true,
      };
    case GET_FILTER_KELURAHAN:
      return {
        ...state,
        listKelurahanData,
        isLoadingFilterKelurahan: false,
      };
    case LOADING_FILTER_KELURAHAN:
      return {
        ...state,
        isLoadingFilterKelurahan: true,
      };
    default:
      return state;
  }
}
